const data = {
  primaryColor: "#03A9F4",
  lightColor: true,
  title: "Formula Solver",
  category: "Education",
  icon: "/images/app-icons/formula-solver.png",
  slogan:
    "Simple and easy-to-use application for physical and chemical calculations",
  shortDescription:
    "Simple and easy-to-use application for physical and chemical calculations with over 100 of formulas in physics and chemistry. Application also features images of the equations, descriptions of elements in the formulas, selector not only of base units for calculation but also the result unit and step-by-step instructions for some formulas",
  fullDescription:
    "Formula Solver is a simple and easy-to-use application for physical and chemical calculations. It features 100+ of formulas in physics and chemistry, with images of the equations, descriptions of elements in the formulas and selector not only of base units for calculation but also the result unit. The formulas of physics are grouped into 12 categories, including electricity, magnetism, hydromechanics, mechanics, mechanics of vibration, mechanics of waves, mechanics of acoustics, molecular physics, thermodynamics, optics, quantum physics, and special theory of relativity. The application also features step-by-step instructions for some formulas. Whether you need help with solving equations in physics and chemistry, Formula Solver is an useful tool for any science enthusiast or student.",
  usesCases: [
    "Helping with physics and chemistry in school",
    "Controlling results after test",
    "To see how some formulas can be solve",
  ],
  properties: [
    "Formulas from 12 categories of physics",
    "100+ formulas across physics and chemistry",
    "Images of equation for given formula",
    "Description of elements in formulas",
    "Showing units of elements",
    "Showing procedure of calculation for some formulas",
    "Possibility to choose not only base unit for calculation and result",
  ],
  services: [],
  pricing: "Free",
  android: {
    permissions: null,
    requirements:
      "This application does not need any special requirements to run.",
    requiredAndroidVersion: "5.0 and up",
    versioning: {
      releasedOn: new Date(2017, 3, 28),
      currentVersion: "5.0.0",
      updatedOn: new Date(2023, 1, 27),
    },
    availableOn: {
      googlePlayURL:
        "https://play.google.com/store/apps/details?id=cz.david_simak.formula_solver",
    },
    languages: {
      supported: "English",
      inProgress: null,
    },
    deviceCompatibility: {
      phone: true,
      tablet: true,
    },
    techInformation: {
      language: "Java 11",
      logging: "ACRA",
      database: "SQLite",
      integrations: [],
      libraries: [],
      plugins: [],
    },
    images: [
      {
        title: "Main screen with physics categories",
        url: "/images/project-screenshots/formula-solver/formula-solver-android-1.png",
        description: "Main screen with selection of categories of physics",
      },
      {
        title: "Main screen with chemistry formulas",
        url: "/images/project-screenshots/formula-solver/formula-solver-android-2.png",
        description: "Main screen with list of formulas for chemistry",
      },
      {
        title: "Category screen with list of formulas",
        url: "/images/project-screenshots/formula-solver/formula-solver-android-3.png",
        description: "Category screen with list of formulas for physics",
      },
      {
        title: "Subcategory screen with list of formulas",
        url: "/images/project-screenshots/formula-solver/formula-solver-android-4.png",
        description:
          "Category screen with list of formulas for subcategory of physics",
      },
      {
        title: "Formula solver screen",
        url: "/images/project-screenshots/formula-solver/formula-solver-android-5.png",
        description:
          "Formula solver screen for calculation of given formula with description, possibility to choose which element to calculate and unit",
      },
      {
        title: "Formula solver screen with result",
        url: "/images/project-screenshots/formula-solver/formula-solver-android-6.png",
        description:
          "Formula solver screen with result of given calculation with possibility to convert to different unit and showing procedure of calculation",
      },
    ],
  },
  frontend: {
    url: "https://formula-solver.davidsimak.dev",
    versioning: {
      releasedOn: new Date(2018, 7, 1),
      currentVersion: "2.0",
      updatedOn: new Date(2023, 1, 27),
    },
    languages: {
      supported: "English",
      inProgress: null,
    },
    responsivenessCompatibility: {
      phone: true,
      tablet: true,
      desktop: true,
    },
    techInformation: {
      language: "JavaScript",
      framework: "ReactJS",
      integrations: [],
      packageManager: "npm",
      webServer: "Nginx",
      virtualization: "Docker container",
      containerOS: "Alpine Linux",
      deployed: "k3s cluster",
    },
    images: [
      {
        title: "Main screen",
        url: "../../images/project-screenshots/formula-solver/formula-solver-web-1.png",
        description:
          "Screen with selection of categories from physics and formulas from chemistry",
      },
      {
        title: "Main screen",
        url: "../../images/project-screenshots/formula-solver/formula-solver-web-2.png",
        description:
          "Screen with selection of categories from physics and formulas from chemistry",
      },
      {
        title: "Main screen",
        url: "../../images/project-screenshots/formula-solver/formula-solver-web-3.png",
        description:
          "Screen with selection of categories from physics and formulas from chemistry",
      },
      {
        title: "Main screen",
        url: "../../images/project-screenshots/formula-solver/formula-solver-web-4.png",
        description:
          "Screen with selection of categories from physics and formulas from chemistry",
      },
      {
        title: "Main screen",
        url: "../../images/project-screenshots/formula-solver/formula-solver-web-5.png",
        description:
          "Screen with selection of categories from physics and formulas from chemistry",
      },
      {
        title: "Main screen",
        url: "../../images/project-screenshots/formula-solver/formula-solver-web-6.png",
        description:
          "Screen with selection of categories from physics and formulas from chemistry",
      },
      {
        title: "Main screen",
        url: "../../images/project-screenshots/formula-solver/formula-solver-web-7.png",
        description:
          "Screen with selection of categories from physics and formulas from chemistry",
      },
    ],
  },
  backend: {
    versioning: {
      releasedOn: new Date(2019, 7, 1),
      currentVersion: "2.0",
      updatedOn: new Date(2023, 1, 27),
    },
    techInformation: {
      language: "Java 17",
      framework: "Spring Boot 2.7.1",
      logging: "Log4j2",
      metrics: "Spring Boot Actuator",
      virtualization: "Docker",
      containerOS: "openjdk:17.0.2-slim",
      deployed: "k3s cluster",
      database: null,
      integrations: [],
    },
  },
};

class FormulaSolverProjectData {
  get() {
    return data;
  }

  getAsItem() {
    return {
      tag: "formula-solver",
      title: data.title,
      category: data.category,
      icon: data.icon,
      shortDescription: data.shortDescription,
      platform: {
        android: data.android !== null,
        frontend: data.frontend !== null,
        backend: data.backend !== null,
      },
    };
  }

  getIfCategoryIsMatched(categoryName) {
    if (categoryName === data.category) {
      return this.getAsItem();
    }

    return undefined;
  }
}

export default new FormulaSolverProjectData();
